import { keyframes } from 'styled-components/macro';

const OFFSET = 8;

export const menuSlideInTop = keyframes`
  from { opacity: 0; transform: translateY(${OFFSET}px); }
  to { opacity: 1; transform: translateY(0);}
`;

export const menuSlideOutTop = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(${OFFSET}px);
  }
`;

export const menuSlideInBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(-${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const menuSlideOutBottom = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-${OFFSET}px);
  }
`;

export const menuSlideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const menuSlideOutLeft = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(${OFFSET}px);
  }
`;

export const menuSlideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-${OFFSET}px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const menuSlideOutRight = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-${OFFSET}px);
  }
`;
